import Layout from "../../components/Layout/Layout";

const EMAIL = "lotcamp@earthboundmartian.com";

const Contact = () => {
  return (
    <Layout>
      <section className="max-w-3xl mx-auto px-6 py-16 w-full">
        <p className="text-sun font-semibold uppercase tracking-wide text-sm">
          LotCamp
        </p>
        <h1 className="text-5xl font-bold text-alt-blk mt-3">Contact</h1>
        <p className="text-xl text-alt-blk/80 mt-6 leading-relaxed">
          Date corrections, lot notes, and “this fest should be on the map”
          messages are welcome. Write to{" "}
          <a
            href={`mailto:${EMAIL}`}
            className="text-turquoise hover:text-mars break-all"
          >
            {EMAIL}
          </a>
          .
        </p>
        <p className="leading-relaxed mt-6">
          v1 has no user accounts. If you know an outdoor metal, pagan, goth,
          or folk gathering worth planning a trip around — especially one with
          a real lot — tell us what camping actually looks like.
        </p>
        <a
          href={`mailto:${EMAIL}`}
          className="inline-block mt-10 bg-mars hover:bg-sunset text-white px-8 py-4 rounded-2xl font-semibold"
        >
          Email LotCamp
        </a>
      </section>
    </Layout>
  );
};

export default Contact;
